import { render, staticRenderFns } from "./TrademarkSearch.vue?vue&type=template&id=0bb45780&"
import script from "./TrademarkSearch.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearch.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports